<template>
<div>
    <div class="row">
        <div class="col-md-6">
            <div>
                <h2 class="text-primary d-inline" style="margin-bottom: 0px;">
                    <i class="fas fa-chart-bar" /> Dashboard
                </h2>
                <span style="text-indent:0px" class="badge badge-info text-white">Beta</span>
            </div>
            <small class="text-muted">Confira aqui os indicadores da sua empresa.</small>
        </div>
    </div>

    <br />


        <b-tabs active-nav-item-class="active-nav-item" content-class="mt-3">
            <b-tab  title="Vendas" active>
                <order-dashboard />
            </b-tab>
            <b-tab title="Produtos">
                <product-dashboard />
            </b-tab>
            <b-tab title="Contas a Receber">
                <bill-receiveble-dashboard />
            </b-tab>
            <b-tab title="Contas a Pagar">
                <bill-payable-dashboard />
            </b-tab>
            <!-- <b-tab title="Financeiro">
                <finance-dashboard />
            </b-tab> -->
        </b-tabs>


</div>
</template>

<script>
// import TablePaginator from "./../components/sections/TablePaginator.vue";
// import InfoCard from "./../components/sections/dashboard/InfoCard.vue";
// import AppBarChart from "./../components/ui/AppBarChart.vue"
// import OrderHistoricChart from "./../components/charts/OrderHistoricChart.vue"
import OrderDashboard from './../components/dashboards/OrderDashboard'
import ProductDashboard from './../components/dashboards/ProductDashboard'
import BillPayableDashboard from './../components/dashboards/BillPayableDashboard'
import BillReceivebleDashboard from './../components/dashboards/BillReceivebleDashboard'
import FinanceDashboard from './../components/dashboards/FinanceDashboard'

export default {
    components: {
        OrderDashboard,
        ProductDashboard,
        BillPayableDashboard,
        BillReceivebleDashboard,
        FinanceDashboard
    },

};
</script>

<style>
.nav-tabs {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
}

.active-nav-item {
    border: none !important;
    border-bottom: solid 3px #1c2f44 !important
}

</style>
